"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckboxRadioList = function CheckboxRadioList(props) {
  var type = props.type,
      disabled = props.disabled,
      className = props.className,
      style = props.style,
      title = props.title,
      description = props.description,
      rest = _objectWithoutProperties(props, ["type", "disabled", "className", "style", "title", "description"]);

  var classes = (0, _classnames["default"])("radio-checkbox-list", type, className);

  var children = _react["default"].Children.toArray(props.children);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkboxRadioList-component"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: style
  }, type === "ext-2" && /*#__PURE__*/_react["default"].createElement("div", {
    className: "header-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "description"
  }, description)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", null, children.map(function (child, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index,
      className: (0, _classnames["default"])(child.props.checked && 'selected', child.props.disabled && 'disabled')
    }, child);
  })))));
};

CheckboxRadioList.propTypes = {
  type: _propTypes["default"].oneOf(["", "ext-1", "ext-2"]),
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  title: _propTypes["default"].string,
  description: _propTypes["default"].string
};
CheckboxRadioList.defaultProps = {
  type: "",
  disabled: false,
  className: "",
  style: {},
  title: "",
  description: ""
};
var _default = CheckboxRadioList;
exports["default"] = _default;